import type { SelectOption } from '@ps/web-shared-components';

import { Country } from '@swf/core/enums';
import countries from '@swf/generated/countries.json';

export const frenchTerritories = [
  Country.Guadeloupe,
  Country.Martinique,
  Country.FrenchGuiana,
  Country.Reunion,
  Country.Mayotte
];

export const countriesWithoutFrenchTerritories = (
  countries as { value: Country; text: string }[]
).filter(({ value }) => !frenchTerritories.includes(value));

export const getFrenchCitiesByState = async (state: string): Promise<SelectOption[]> => {
  try {
    const frenchCitiesByState = (
      await import(
        /* webpackChunkName: "french-cities" */ '@swf/generated/french-cities-by-state.json'
      )
    ).default;
    return frenchCitiesByState[state] || [];
  } catch {
    return [];
  }
};
